import React from "react";
import {ChevronRight, Mail, MapPin, Phone} from "lucide-react";

const Footer = (props) => {
    // Function to handle service click
    const handleServiceClick = (serviceId, e) => {
        if (props.onServiceClick) {
            e.preventDefault();
            props.onServiceClick(serviceId);
        }
    };

    return (
        <footer className="pt-10 pb-5 footer-area text-white ">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
                    <div className="md:col-span-2">
                        <h3 className="text-xl font-semibold mb-4">À Propos de nous</h3>
                        <p className="mb-6 text-gray-300">
                            MesProcédures.fr est une société française spécialisée dans
                            l'accompagnement administratif . En collaborant avec des avocats spécialisés et des experts,
                            nous offrons un suivi rigoureux et accessible. À terme, nous visons à simplifier les
                            démarches administratives et juridiques pour tous, à des prix compétitifs.
                        </p>
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 md:col-span-2 lg:col-span-3">
                        <div className="md:col-span-1 mb-4">
                            <h3 className="text-xl font-semibold mb-4">Liens rapides</h3>
                            <ul className="space-y-2 text-gray-300">
                                {[
                                    {href: props.home, text: "Accueil"},
                                    {href: "/#service", text: "Nos services"},
                                    {href: props.about, text: "Qui sommes-nous ?"},
                                    {href: props.articles, text: "Nos articles"},
                                    {href: props.location, text: "Où nous rencontrer ?"},
                                    {href: props.contact, text: "Nous contacter"},
                                    {href: props.privacy, text: "Politique de Confidentialité"},
                                ].map((link, i) => (
                                    <li key={i}>
                                        <a
                                            href={link.href}
                                            className="hover:text-gray-400 flex items-center"
                                        >
                                            <ChevronRight size={16} className="mr-2"/> {link.text}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="md:col-span-1 mb-4">
                            <h3 className="text-xl font-semibold mb-4">Services</h3>
                            <ul className="space-y-2 text-gray-300">
                                {[
                                    {id: 1, text: "Naturalisation"},
                                    {id: 2, text: "Titre de séjour"},
                                    {id: 3, text: "OQTF"},
                                    {id: 4, text: "Accélération des procédures"},
                                    {id: 6, text: "Dossier bloqué en préfecture\n"},
                                ].map((service, i) => (
                                    <li key={i}>
                                        <a
                                            href="#"
                                            onClick={(e) => handleServiceClick(service.id, e)}
                                            className="hover:text-gray-400 flex items-center"
                                        >
                                            <ChevronRight size={16} className="mr-2"/>
                                            {service.text}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="col-span-2 md:col-span-1 lg:col-span-1 sm:col-span-1 mb-4">
                            <h3 className="text-xl font-semibold mb-4">Contact Info</h3>
                            <ul className="space-y-2 text-gray-300">
                                {[
                                    {
                                        text: (
                                            <span className="break-all block w-full">
                        contact@mesprocedures.fr
                      </span>
                                        ),
                                        href: "mailto:contact@mesprocedures.fr",
                                        icon: <Mail size={22} className="text-blue-500"/>,
                                    },
                                    {
                                        href: "tel:+33189715961",
                                        text: "+33 1 89 71 59 61",
                                        icon: <Phone size={22} className="text-blue-500"/>,
                                    },
                                    {
                                        text: (
                                            <span className=" block w-full">
                        47 Av. du Docteur Arnold Netter
                        75012 Paris
                      </span>
                                        ),
                                        href: "https://maps.app.goo.gl/y3UTNQT6iWkFKmMP8",
                                        icon: <MapPin size={22} className="text-blue-500"/>,
                                    },
                                ].map((link, i) => (
                                    <li key={i} className="flex items-center">
                    <span
                        className="bg-white w-10 h-10 rounded-md border border-gray-300 flex items-center justify-center mr-3 flex-shrink-0">
                      {link.icon}
                    </span>
                                        <a href={link.href} target={"_blank"} className="hover:text-gray-400">
                                            {link.text}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"text-center pt-10"}>
                <span>Copyright © 2025 Mes Procédures</span>
            </div>
        </footer>
    );
};

export default Footer;
